import type { VenueData } from './types';

interface WelcomeBannerProps {
  venue: VenueData;
}

export const WelcomeBanner = ({ venue }: WelcomeBannerProps) => {
  return (
    <div className="bg-gray-100 border border-gray-200 rounded-lg p-6 mb-6">
      <h2 className="font-serif text-xl font-normal leading-tight text-gray-900 mb-2">
        Welcome to Venue Management
      </h2>
      <p className="text-gray-700 max-w-prose">
        This is your central hub for managing all aspects of {venue.name}.
        From here you can update venue information, manage wines, view statistics,
        and handle events and experiences.
      </p>
    </div>
  );
};